
    <fieldmagic-primary-button
      label="Import from template"
      icon="import"
      (click)="onClick()"
    >
    </fieldmagic-primary-button>
  